import comp from "./LearningStandards";
export default comp;
